import { Outlet, useLoaderData } from 'react-router';
import { FirebaseOptions } from 'firebase/app'
import type { LoaderFunction, MetaFunction } from 'react-router';
import { Firebase } from '~/external-services/firebase'
import { useStaffAuth } from '~/hooks/auth'

export const meta: MetaFunction = () => ([
  {charset: 'utf-8'},
  {title: 'Cycle Mikke'},
  {viewport: 'width=device-width,initial-scale=1'},
  {robots: 'noindex'},
])

export const loader: LoaderFunction = async () => {
  const config: FirebaseOptions = {
    apiKey: process.env.API_KEY,
    authDomain: process.env.AUTH_DOMAIN,
    projectId: process.env.PROJECT_ID,
    storageBucket: process.env.STORAGE_BUCKET,
    messagingSenderId: process.env.MESSAGING_SENDER_ID,
    appId: process.env.APP_ID,
    measurementId: process.env.MEASUREMENT_ID,
  }
  return config
}

export default function Admin() {
  const config = useLoaderData<FirebaseOptions>();
  const firebase = new Firebase('staff', config)
  useStaffAuth(firebase)

  return <Outlet />
}
